import React, { Component } from "react";
import { Link } from "react-router";

const tabs = [
  { label: "Pending", url: "/requests/pending" },
  { label: "Approved/Refused", url: "/requests/approved" },
];

class RepresentiveRequests extends Component {
  render() {
    const { location } = this.props;

    return (
      <div className="site--width">
        <NavigationButtons tabs={tabs} activeUrl={location.pathname} />
        {this.props.children}
      </div>
    );
  }
}

export default RepresentiveRequests;

class NavigationButtons extends Component {
  render() {
    const { tabs, activeUrl } = this.props;

    const isUrlActive = (url) => activeUrl.includes(url);

    return (
      <div className="group-navigation">
        {tabs.map(({ label, url }, idx) => (
          <Link
            className={`button_classic group-navigation-button ${
              isUrlActive(url) && "active"
            }`}
            to={url}
            key={idx}
          >
            {label}
          </Link>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/RepresentiveRequests/index.jsx